import { AxiosResponse } from "axios";
import { ServerResponse } from "../remoteExecution/RemoteExecutionServiceImpl";

/**
 * HTTP statuses treated as success for Worky remote calls (body may still be empty for 204).
 */
const isWorkySuccessfulHttpStatus = (status: number | undefined): boolean => {
    if (status == null) {
        return false;
    }
    return status === 200 || status === 201 || status === 202 || status === 204;
};

/**
 * True when the axios response has a success status and a non-null {@link ServerResponse.data} payload.
 */
const isValidWorkyServerResponseWithData = <T, E>(
    apiResponse: AxiosResponse<ServerResponse<T, E>> | undefined
): apiResponse is AxiosResponse<ServerResponse<T, E>> & { data: ServerResponse<T, E> & { data: T } } => {
    if (apiResponse?.data == null) {
        return false;
    }
    if (!isWorkySuccessfulHttpStatus(apiResponse.status)) {
        return false;
    }
    return apiResponse.data.data != null;
};

export { isWorkySuccessfulHttpStatus, isValidWorkyServerResponseWithData };
